var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpirationToken(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "auto",
    height: "auto",
    viewBox: "0 0 748.596 462.651",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3834",
    "data-name": "Trac\\xE9 3834",
    d: "M0,0H117.672V85.125H0Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3838",
    "data-name": "Trac\\xE9 3838",
    d: "M0,0H122.679V130.191H0Z",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21945",
    "data-name": "Groupe 21945",
    transform: "translate(-507.178 -299.922)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21886",
    "data-name": "Groupe 21886",
    transform: "translate(0 63.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3831",
    "data-name": "Trac\\xE9 3831",
    d: "M100.678,353.028C85.8,353,91.921,307.675,93.152,299.621c4.479-29.256,20.62-50.606,42.684-69.992,29.331-25.755,58.506-47.2,80.971-79.583,21.766-31.375,40.521-67.454,75.824-85.764C388.4,14.628,474.583,143.472,547.136,186.54c33.128,19.667,51.451,50.291,56.295,88.469,1.7,13.436-2.664,78.012-24.692,78.012l-478.061.007Z",
    transform: "translate(542.822 193.805)",
    fill: "#ecf4fd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21883",
    "data-name": "Groupe 21883",
    transform: "translate(1138.102 461.099)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3832",
    "data-name": "Trac\\xE9 3832",
    d: "M329.327,204.966c10.131,9.768-18.858,26.979-18.858,26.979l19.251,14.745c16.924-3.755,15.416-16.167,15.416-16.167-.372-3.009,4.141-6.771,4.141-6.771,12.032-6.771,5.565-17.3,5.565-17.3-2.779-4.529.815-10.622,4.311-13.477a15.931,15.931,0,0,1,5.046-2.3c3.105-1.024,6.261-2.062,7.1-5.255.455-1.768-.154-3.516-.767-5.282a18.935,18.935,0,0,1-.831-2.857c-.8-4.449,2.18-8.413,5.859-10.542.769-.452,1.592-.857,2.416-1.261,2.281-1.121,4.577-2.251,5.811-4.4,1.677-2.931.634-6.856-1.739-9.274s-5.735-3.569-9.054-4.182c-5.914-1.091-12.3-.643-17.579,2.276-7.577,4.18-11.773,12.735-13.319,21.226-1.151,6.355-1.975,10.9-7.664,14.462-.657.413-1.339.808-2.023,1.2-3.491,2.019-7.03,4.07-7.476,8.594C324.6,198.926,326.861,202.585,329.327,204.966Zm57.967-.351c-13.243,1.5-39.749,32.078-39.749,32.078l18.463,13.4c7.43-1.438,25.3-11.9,27.871-19.517.813-2.412.475-5.349.142-8.241-.436-3.774-.861-7.469,1.3-9.818,1.743-1.906,4.529-3.016,6.925-3.813l.018-.007c1.3-.427,8.415-2.77,9.57-1.644-5.923-5.749,3.468-2.935,3.468-2.935,2.788-1.426,3.195-7.31,3.507-11.812a31.673,31.673,0,0,1,.466-4.341c.524-2.184,6.068-17.253,8.615-16.72-11.022-2.265-21.867,2.028-29.857,9.63-3.4,3.238-5.328,7.283-6.84,11.667-.159.455-.411,1.534-.724,2.873-.838,3.606-2.115,9.081-3.172,9.2Z",
    transform: "translate(-310.513 -145.403)",
    fill: "#cde5f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21882",
    "data-name": "Groupe 21882",
    transform: "translate(10.027 1.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3833",
    "data-name": "Trac\\xE9 3833",
    d: "M382.821,147.074c-2.418,4.7-6.481,7.111-11.185,9.093-2.963,1.252-6.479,2.131-8.946,4.316-3.558,3.137-2.508,7.014-3.872,11.185a10.354,10.354,0,0,1-4.26,5.8c-8.523,5.044-13.675,9.476-14.915,19.906-1.775,14.708-9.056,35.957-24.788,42.264m107.344-68.4a39.813,39.813,0,0,0-22.691,21.04c-1.95,4.412-2.01,9.531-5.563,13.041s-8.911,4.949-13.236,7.457c-7.949,4.582-19.311,19.476-20.974,28.233",
    transform: "translate(-314.854 -147.074)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.174
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3835",
    "data-name": "Trac\\xE9 3835",
    d: "M51.613,183.6H756.107",
    transform: "translate(491.928 363.063)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21885",
    "data-name": "Groupe 21885",
    transform: "translate(507.178 416.032)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3836",
    "data-name": "Trac\\xE9 3836",
    d: "M140.232,209.745c-14.83,8.976,18.73,49.834,18.73,49.834l-30.551.186q-1.44-.68-2.825-1.47l-21.736,4.55c-8.36-.4-17.163-3.144-21.208-11.054-1.277-2.5-1.383-5.767-1.488-8.98-.138-4.2-.271-8.307-3.009-10.528-2.221-1.805-5.443-2.561-8.192-3.045-1.426-.25-9.658-1.674-10.749-.25,5.556-7.262-4.263-2.664-4.263-2.664-3.275-1.121-4.674-7.483-5.742-12.349a35.034,35.034,0,0,0-1.215-4.665c-.932-2.3-9.417-17.866-12.117-16.888,11.676-4.256,24.237-1.316,34.193,5.7,4.244,2.993,7,7.1,9.364,11.649.248.473.7,1.6,1.259,2.99,1.5,3.746,3.783,9.426,4.947,9.577,1.36.177,15.56,10.51,28.1,19.8a15.333,15.333,0,0,1,.567-6c1.272-3.512-3.124-9.258-3.124-9.258-12.623-11.417-1.971-22.306-1.971-22.306,4.577-4.681,1.918-12.96-1.5-17.365a19.612,19.612,0,0,0-5.452-4.166c-3.445-2.072-6.941-4.173-7.078-8.229-.071-2.248,1.128-4.175,2.347-6.128a23.328,23.328,0,0,0,1.775-3.215c2.168-5.131-.324-10.691-4.171-14.272q-1.233-1.128-2.545-2.166c-2.441-1.984-4.887-3.969-5.788-6.89-1.217-3.962,1.132-8.394,4.616-10.652s7.85-2.729,12-2.559c7.428.3,14.975,2.588,20.526,7.538,7.937,7.074,10.648,18.507,10.186,29.127v.016c-.347,7.94-.593,13.59,5.262,19.444.687.687,1.408,1.357,2.131,2.033,3.64,3.385,7.327,6.814,6.61,12.349-.565,4.352-4.276,8.13-7.894,10.315Z",
    transform: "translate(-35.667 -123.91)",
    fill: "#cde5f9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21884",
    "data-name": "Groupe 21884",
    transform: "translate(0.2 0.177)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3837",
    "data-name": "Trac\\xE9 3837",
    d: "M84.939,126.8c1.624,6.3,5.859,10.308,10.955,13.978,3.2,2.313,7.2,4.343,9.591,7.623,3.42,4.736,1.1,9.116,1.6,14.511a12.726,12.726,0,0,0,3.553,8.123c8.863,8.381,13.849,15.115,12.508,27.988-1.888,18.155-1.888,45.813,15.324,57.7m-102.6-61.591A44.067,44.067,0,0,1,64.1,214.465c2.846,4.506,3.73,10.089,8.188,13.355,4.545,3.335,10.542,3.964,15.673,5.988,9.435,3.73,15.852,13.195,19.093,22.505",
    transform: "translate(-35.867 -126.8)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.174
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3839",
    "data-name": "Trac\\xE9 3839",
    d: "M110.448,155.485a17.294,17.294,0,0,1,.533-4.949c.117-.462.845-.3.723.165a16.789,16.789,0,0,0-.533,4.759.371.371,0,0,1-.627.285.372.372,0,0,1-.119-.26",
    transform: "translate(568.189 319.832)",
    fill: "#010344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3840",
    "data-name": "Trac\\xE9 3840",
    d: "M145.408,248.164l1.514-24.641,18.7,3.856-4.13,25Z",
    transform: "translate(613.553 414.831)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3841",
    "data-name": "Trac\\xE9 3841",
    d: "M146.69,234.252l-2.269,15.333H153.5l.944-2.269,1.895,3.025h24.786v-4.922l-13.812-4.731-.57-3.025-20.055-3.411Z",
    transform: "translate(612.273 428.744)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3842",
    "data-name": "Trac\\xE9 3842",
    d: "M153.153,241.249l3.408-4.731,2.834,6.532,4.545-3.691,1.794,4.825,2.147-2.366",
    transform: "translate(623.596 431.682)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3843",
    "data-name": "Trac\\xE9 3843",
    d: "M68.568,219.225l20.124-14.3,8.748,16.973L75.4,234.385Z",
    transform: "translate(513.914 390.71)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3844",
    "data-name": "Trac\\xE9 3844",
    d: "M76.1,211.149l-13.348,7.869,5.705,7.062,2.366-.687-1.167,3.372,15.576,19.283,3.824-3.089-5-13.723,2-2.343L76.1,211.149Z",
    transform: "translate(506.375 398.786)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3845",
    "data-name": "Trac\\xE9 3845",
    d: "M70.068,220.076l5.822-.324-3.3,6.311,5.726,1.215-2.625,4.433,3.186.181",
    transform: "translate(515.859 409.941)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3846",
    "data-name": "Trac\\xE9 3846",
    d: "M152.505,101.364c-5.119,2.717-9.109.926-10.8-2.664-1.555-3.355.073-8.369,4.655-8.332a11.646,11.646,0,0,1,5.3,1.486,16.35,16.35,0,0,1,1.982,2.979c1.1,2.184,1.741,5.03-1.141,6.553",
    transform: "translate(608.012 242.166)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3847",
    "data-name": "Trac\\xE9 3847",
    d: "M152.311,114.516c10.122,4,16.784-2.021,17.765-10.82.432-3.9.533-8.176-1.162-11.782a12.711,12.711,0,0,0-7.669-7.049c-7.347-2.216-15.3,2.632-17.76,10.824a.1.1,0,0,1-.028.08,15.388,15.388,0,0,0,8.854,18.746Z",
    transform: "translate(610.141 234.336)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3848",
    "data-name": "Trac\\xE9 3848",
    d: "M148.834,95.049a5.446,5.446,0,0,0-5.967-3.2c-.671.129-.574,1.194.1,1.066a4.375,4.375,0,0,1,4.864,2.48c.283.632,1.284.264,1-.367",
    transform: "translate(609.666 243.979)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3849",
    "data-name": "Trac\\xE9 3849",
    d: "M148.178,94.906l-2.8,12.244,8.957,2.051,2.8-12.244Z",
    transform: "translate(613.508 248.052)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3850",
    "data-name": "Trac\\xE9 3850",
    d: "M152.581,92.509a1,1,0,1,1,0-1.341.953.953,0,0,1,0,1.341Zm3.994,6.174a21.559,21.559,0,0,0,.836-6.206c0-.611-.948-.728-.944-.11a20.553,20.553,0,0,1-.8,5.965C155.5,98.9,156.41,99.259,156.575,98.683Z",
    transform: "translate(620.584 242.773)",
    fill: "#010344"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3851",
    "data-name": "Trac\\xE9 3851",
    d: "M168.988,100.322c-3.468-.482-15.08-6.654-17.269.328-.533,1.78-.533,4.077-2.4,4.005a2.191,2.191,0,0,1-1.89-2.1,12.526,12.526,0,0,0-4.642-.407c0-12.177,6.015-15.294,9.157-14.345,0,0,10.34-11.64,14.352-3.558,0,0,12.868-5.721,14.8,6.553s-12.1,9.52-12.1,9.52Z",
    transform: "translate(610.152 230.53)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3852",
    "data-name": "Trac\\xE9 3852",
    d: "M187.423,116.346c-.868,6.222-13.121,9.685-27.37,7.74s-25.133-8.576-24.285-14.8,13.105-9.692,27.349-7.756,25.138,8.576,24.285,14.8m32.312,42.829,17.717-2.051s21.6-35.909,27.935-49.246l7.43-9.279c4.55,0,9.1-.305,13.654-.184,1.842.053,4.32-.2,5.891.88,1.247.857,2.664,2.552,2.131,4.182-.88,2.694-5.386,3.659-7.683,4.26-1.337.342-2.694.618-4.054.864-.533.1-4.825.473-4.906.74l-7.99,27.482c-4.793,16.408-6.084,33.341-18.346,46.345-11.991,12.694-28.557,18.766-44.974,10.4-31.766-16.187,13.2-34.359,13.2-34.359",
    transform: "translate(600.992 252.545)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3853",
    "data-name": "Trac\\xE9 3853",
    d: "M123.77,157.765s-8.326,23.029,45.413,87.319L169.3,349.8h23.684s46.6-99.932-.707-205.951l-68.511,13.92Z",
    transform: "translate(584.891 311.512)",
    fill: "#129faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3854",
    "data-name": "Trac\\xE9 3854",
    d: "M69.31,285.638l15.257,30.229c1.327,2.632,50.073-17.653,53.323-19.037,30.475-13.11,62.581-29.832,84.08-55.838,11.918-14.382,18.592-32.218,22.443-50.335a263.246,263.246,0,0,0,4.155-27.6c.581-5.565-.106-18.642,8.176-16.311l-65.222.22s-10.057,39.184-13.638,72.551L69.312,285.638Z",
    transform: "translate(514.875 314.917)",
    fill: "#129faf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3856",
    "data-name": "Trac\\xE9 3856",
    d: "M197.45,116.841a11.431,11.431,0,0,0,5.859-1.337c4.591-2.708,5.087-9.318,4.713-13.792,0,0,30.05,8.406,48.024,42.955,2.807,5.4,6.311,5.978,16.194,7.262,1.369.175.813,7.042.574,11.718-.388,7.425-5.983,31.653-7,35.445,0,0-23.971,2.354-34.586-13.2l-8.172,24.834a60.893,60.893,0,0,1-24.5,6.888,63.733,63.733,0,0,1-11.369-.246c-9.371-1.034-19-3.234-27.7-7.494-6.925-3.383-16.24-6.766-21.69-12.31l3.383-24.253c-19.322-2.91-33.029-20.078-33.029-20.078C125.45,92.56,186.2,99.694,186.2,99.694q-.057.179-.106.361c-1.332,4.469-2.207,9.419,1.853,13.723,2.35,2.5,6.259,3.064,9.529,3.064",
    transform: "translate(565.236 253.926)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3857",
    "data-name": "Trac\\xE9 3857",
    d: "M190.241,167.878,174.292,214.4M145.611,97.073s8.891,3.937,12.758,1.6",
    transform: "translate(613.816 250.862)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3858",
    "data-name": "Trac\\xE9 3858",
    d: "M221.925,132.8H94.175a11.417,11.417,0,0,0-11.417,11.442v64.349A11.423,11.423,0,0,0,94.17,220.013H219.357a11.419,11.419,0,0,0,11.373-11.447V141.622a8.819,8.819,0,0,0-8.822-8.822",
    transform: "translate(532.314 297.189)",
    fill: "#79a4e2",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3859",
    "data-name": "Trac\\xE9 3859",
    d: "M218.645,215.653H84.939a7.154,7.154,0,0,1-7.154-7.154V135.622a7.157,7.157,0,0,1,7.154-7.154H218.645a7.157,7.157,0,0,1,7.154,7.154V208.5A7.157,7.157,0,0,1,218.645,215.653Z",
    transform: "translate(525.865 291.572)",
    fill: "#ebf4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3860",
    "data-name": "Trac\\xE9 3860",
    d: "M80.394,133.413v23.438L62.923,143.838Z",
    transform: "translate(506.594 297.984)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3862",
    "data-name": "Trac\\xE9 3862",
    d: "M110.934,161.307H80.426a4,4,0,0,1-4-3.992V126.8a4.008,4.008,0,0,1,4-3.994h30.507a4,4,0,0,1,4,3.994v30.512A4.01,4.01,0,0,1,110.934,161.307Z",
    transform: "translate(524.107 284.234)",
    fill: "#ccddf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3863",
    "data-name": "Trac\\xE9 3863",
    d: "M108.813,159.318H78.3a4,4,0,0,1-4-3.994V124.815a4,4,0,0,1,4-3.994h30.512a4,4,0,0,1,4,3.994v30.51a4.005,4.005,0,0,1-4,3.994Z",
    transform: "translate(521.354 281.656)",
    fill: "#c52b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3864",
    "data-name": "Trac\\xE9 3864",
    d: "M109.171,141.536a6.706,6.706,0,1,1-4.971-6.477,6.7,6.7,0,0,1,4.971,6.477Zm-5.423,49.046a3.993,3.993,0,1,1-3.993-3.993,3.993,3.993,0,0,1,3.993,3.993Zm16.371,0a4,4,0,1,1-.305-1.532,4.015,4.015,0,0,1,.305,1.532Zm15.473,0a4,4,0,1,1-3.994-3.861A4,4,0,0,1,135.592,190.582Zm-1.24-49.43H117.306a1.252,1.252,0,0,1-1.243-1.24v-1a1.252,1.252,0,0,1,1.243-1.243h17.046a1.249,1.249,0,0,1,1.24,1.242v1A1.249,1.249,0,0,1,134.352,141.152Zm23.81,0H141.116a1.249,1.249,0,0,1-1.24-1.24v-1a1.249,1.249,0,0,1,1.24-1.243h17.046a1.252,1.252,0,0,1,1.243,1.243v1A1.249,1.249,0,0,1,158.162,141.152Zm-16.626,7.09H116.98a.9.9,0,0,1-.9-.9v-.723a.9.9,0,0,1,.9-.9h24.556a.9.9,0,0,1,.9.9v.723a.9.9,0,0,1-.9.9Zm-1.883,9.21H98.032a.253.253,0,0,1-.17-.069.239.239,0,0,1-.069-.17v-.193a.246.246,0,0,1,.069-.17.239.239,0,0,1,.17-.074h41.621a.251.251,0,0,1,.243.243v.193a.241.241,0,0,1-.074.17.246.246,0,0,1-.17.069Zm39.878,0H153.9a.211.211,0,0,1-.092-.018.222.222,0,0,1-.129-.129.211.211,0,0,1-.018-.092v-.193a.246.246,0,0,1,.069-.17.241.241,0,0,1,.17-.074h25.629a.24.24,0,0,1,.17.073.246.246,0,0,1,.069.17v.193a.252.252,0,0,1-.018.092.248.248,0,0,1-.129.129.219.219,0,0,1-.092.018Zm-22.306,5.285H98.032a.239.239,0,0,1-.239-.239v-.193a.246.246,0,0,1,.069-.17.239.239,0,0,1,.17-.073h59.193a.253.253,0,0,1,.172.071.256.256,0,0,1,.073.172v.193a.25.25,0,0,1-.073.17.253.253,0,0,1-.172.069Zm-.678,9.807H97.354a.243.243,0,0,1-.172-.073.248.248,0,0,1-.073-.172v-.191a.253.253,0,0,1,.246-.246h59.193a.243.243,0,0,1,.239.246v.191a.243.243,0,0,1-.239.246Zm-43.925-4.793H98.186a.239.239,0,0,1-.239-.241v-.191a.241.241,0,0,1,.069-.172.248.248,0,0,1,.17-.073h14.437a.243.243,0,0,1,.239.246v.191a.234.234,0,0,1-.071.17.232.232,0,0,1-.168.071Zm81.9,0H120.411a.239.239,0,0,1-.17-.071.234.234,0,0,1-.071-.17v-.191a.246.246,0,0,1,.241-.246h74.113a.251.251,0,0,1,.246.246v.191a.246.246,0,0,1-.246.241Z",
    transform: "translate(549.172 299.822)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3865",
    "data-name": "Trac\\xE9 3865",
    d: "M135.459,207.8c-39.627-43.794-24.924-84.785-24.924-84.785l39.474,4.348L139,151.443l4.017,56.24,1.886,8.748s5.8,5.859,5.813,5.859c.595.6.133,2.462-.266,3.016-1.95,2.706-5.188,1.748-7.623.31a26.369,26.369,0,0,1-3.654-2.692c-.891-.756-2.983-1.987-3.052-3.195l-.673-11.913",
    transform: "translate(564.873 284.504)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3866",
    "data-name": "Trac\\xE9 3866",
    d: "M108.136,136.259s17.85,24.834,37.154,23.438l25.069-25.618-34.97-21.552-20.381,6.585Z",
    transform: "translate(565.223 270.901)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3867",
    "data-name": "Trac\\xE9 3867",
    d: "M167.782,117.954s-20.324,21.75-22.492,34.71c0,0-16.183,2.451-37.154-23.438",
    transform: "translate(565.223 277.938)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3868",
    "data-name": "Trac\\xE9 3868",
    d: "M124.743,166.637s6.759,5.011,7.584.958c0,0,1.024-3.195-8.819-5.795",
    transform: "translate(585.154 334.794)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3869",
    "data-name": "Trac\\xE9 3869",
    d: "M124.743,166.637s6.759,5.011,7.584.958c0,0,1.024-3.195-8.819-5.795",
    transform: "translate(585.154 334.794)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3870",
    "data-name": "Trac\\xE9 3870",
    d: "M239.786,190s9.481,2.343,13,.9M140.454,103.361s-18.98,8.479-23.188,16.465",
    transform: "translate(577.061 259.016)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3871",
    "data-name": "Trac\\xE9 3871",
    d: "M75.115,187.644v16.69S73.455,217.726,87.563,218h28.4M318.433,154.64s20.062-2.184,24.446-22.767",
    transform: "translate(522.324 295.987)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3872",
    "data-name": "Trac\\xE9 3872",
    d: "M200.076,101.477s15.854,2.457-2.843,5.967Z",
    transform: "translate(680.756 256.573)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3873",
    "data-name": "Trac\\xE9 3873",
    d: "M200.076,101.477s15.854,2.457-2.843,5.967",
    transform: "translate(680.756 256.573)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3874",
    "data-name": "Trac\\xE9 3874",
    d: "M299.123,251.647h-135.8a6.392,6.392,0,0,1-6.392-6.392V155.289a6.392,6.392,0,0,1,6.392-6.392H299.155a6.387,6.387,0,0,1,6.394,6.392v89.967a6.394,6.394,0,0,1-6.394,6.392",
    transform: "translate(628.49 318.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3875",
    "data-name": "Trac\\xE9 3875",
    d: "M299.136,148.9H163.309a6.392,6.392,0,0,0-6.392,6.392v89.967a6.392,6.392,0,0,0,6.392,6.392H299.136a6.392,6.392,0,0,0,6.392-6.392V155.289a6.392,6.392,0,0,0-6.392-6.392Z",
    transform: "translate(628.477 318.063)",
    fill: "none",
    stroke: "#221715",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3876",
    "data-name": "Trac\\xE9 3876",
    d: "M157.047,184.963v13.174a6.362,6.362,0,0,0,6.392,6.307H298.745a6.36,6.36,0,0,0,6.392-6.307V184.963H157.047Z",
    transform: "translate(628.645 364.83)",
    fill: "#cde5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3877",
    "data-name": "Trac\\xE9 3877",
    d: "M183.637,193.891,178.6,219.625s-2.706,10.064,3.872,10.255h62.5s-1.55-4.837-3.872-4.449H215.565s-2.52-1.353-1.55-6.392l5.418-25.154-35.8,0Z",
    transform: "translate(655.881 376.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3878",
    "data-name": "Trac\\xE9 3878",
    d: "M183.637,193.891,178.6,219.625s-2.706,10.064,3.872,10.255h62.5s-1.55-4.837-3.872-4.449H215.565s-2.52-1.353-1.55-6.392l5.418-25.154-35.8,0Z",
    transform: "translate(655.881 376.4)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3879",
    "data-name": "Trac\\xE9 3879",
    d: "M179.587,204.4l36.394-3.728,1.461-6.782h-35.8l-2.056,10.51Z",
    transform: "translate(657.873 376.403)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3880",
    "data-name": "Trac\\xE9 3880",
    d: "M410.169,115.959h-93.7a8.374,8.374,0,0,0-8.374,8.374v47.2a8.383,8.383,0,0,0,8.374,8.4h91.795a8.371,8.371,0,0,0,8.374-8.374V122.427a6.469,6.469,0,0,0-6.472-6.468Z",
    transform: "translate(824.517 275.352)",
    fill: "#79a4e2",
    opacity: 0.44
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3881",
    "data-name": "Trac\\xE9 3881",
    d: "M405.848,176.727H311.61a7.147,7.147,0,0,1-7.15-7.154V119.932a7.151,7.151,0,0,1,7.15-7.15h94.239a7.151,7.151,0,0,1,7.154,7.15v49.641a7.152,7.152,0,0,1-7.154,7.154Z",
    transform: "translate(819.798 271.232)",
    fill: "#cde5f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3882",
    "data-name": "Trac\\xE9 3882",
    d: "M318.494,120.876a4.923,4.923,0,1,1-4.93-4.916,4.923,4.923,0,0,1,4.93,4.916Z",
    transform: "translate(825.229 275.353)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3883",
    "data-name": "Trac\\xE9 3883",
    d: "M322.227,137.68a2.928,2.928,0,1,1-1.549-2.591,2.951,2.951,0,0,1,1.549,2.591Zm12.407,0a2.935,2.935,0,0,1-5.813.581,2.935,2.935,0,1,1,5.813-.581Zm12.421,0a2.935,2.935,0,1,1-1.641-2.631A2.933,2.933,0,0,1,347.054,137.68Z",
    transform: "translate(835.219 299.71)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3884",
    "data-name": "Trac\\xE9 3884",
    d: "M349.8,124.725H311.176c-1.2,0-2.2-.505-2.2-1.123v-.3c0-.618.992-1.125,2.2-1.125H349.8c1.208,0,2.2.508,2.2,1.125v.3C352,124.219,351.01,124.725,349.8,124.725Zm12.806,8.45H310.073c-.6,0-1.093-.367-1.093-.815v-.218c0-.452.492-.82,1.093-.82h52.535a.964.964,0,0,1,1.066.82v.218C363.674,132.807,363.178,133.174,362.608,133.174Zm10.163-4.226h-62.7c-.6,0-1.093-.367-1.093-.815v-.218c0-.448.492-.815,1.093-.815h62.7c.6,0,1.091.367,1.091.815v.218C373.862,128.581,373.373,128.948,372.771,128.948Zm-.367,9.132h-63.13c-.161,0-.294-.1-.294-.218v-.08a.265.265,0,0,1,.1-.17.257.257,0,0,1,.191-.055H372.4a.258.258,0,0,1,.191.055.266.266,0,0,1,.1.17v.057c0,.117-.133.218-.294.218m0,3.39h-63.13c-.161,0-.294-.1-.294-.218v-.06c0-.122.133-.218.294-.218H372.4c.161,0,.294.1.294.218v.06C372.7,141.351,372.564,141.447,372.4,141.447Zm-46.8,4.18h-16.4a.225.225,0,0,1-.154-.062.222.222,0,0,1-.064-.156v-.057a.214.214,0,0,1,.064-.154.218.218,0,0,1,.154-.064h16.4a.207.207,0,0,1,.152.064.23.23,0,0,1,.067.154v.057a.223.223,0,0,1-.064.156.225.225,0,0,1-.154.062",
    transform: "translate(825.658 283.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3885",
    "data-name": "Trac\\xE9 3885",
    d: "M280.329,130.263s18.891,2.664,21.111-12.912",
    transform: "translate(788.507 277.157)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3886",
    "data-name": "Trac\\xE9 3886",
    d: "M218.064,284.388H321.97c4.908,0,8.082,1.709,7.937,6.8-.057,1.948,0,3.914,0,5.859v56.8M133.844,48.612c6.98,7.813,15.076,15.1,24.409,19.97,8.56,4.465,18.5,6.771,27.992,5.018,4.134-.767,8.863-3.238,8.918-7.457.053-4.022-4.2-6.626-8.029-7.878a48.2,48.2,0,0,0-21.653-1.9C158.253,57.4,150.341,61.1,148.6,68.189c-1.355,5.5,1.539,11.213,5.326,15.4a36.649,36.649,0,0,0,23.045,11.72c19.91,2.092,15.879-19.582-4.295-16.941-3.728.489-7.57,1.13-10.8,3.084s-5.749,5.524-5.381,9.279a12.456,12.456,0,0,0,2.446,5.737,33.2,33.2,0,0,0,16.284,12.386c3.59,1.24,8.764,1.066,9.812-2.568.6-2.131-.7-4.389-2.5-5.657-4.694-3.3-12.386.133-13.073,5.822-.944,7.8,8.261,9.86,14.106,9.864",
    transform: "translate(598.559 188.022)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3887",
    "data-name": "Trac\\xE9 3887",
    d: "M79.069,124.1l-1.477,1.474,21.929,21.991L101,146.088Z",
    transform: "translate(525.615 285.904)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3888",
    "data-name": "Trac\\xE9 3888",
    d: "M100.366,124.327,77.376,145.2l1.4,1.546,22.992-20.877Z",
    transform: "translate(525.334 286.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3890",
    "data-name": "Trac\\xE9 3890",
    d: "M226.919,118.8h-9.056a2.658,2.658,0,0,1-2.662-2.662v-9.249a2.671,2.671,0,0,1,2.662-2.664h9.056a2.664,2.664,0,0,1,2.664,2.664v9.249a2.664,2.664,0,0,1-2.664,2.662Z",
    transform: "translate(704.055 260.143)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3891",
    "data-name": "Trac\\xE9 3891",
    d: "M219.926,112.412v-11.1s1.959-2.051,3.532.177v10.919",
    transform: "translate(710.182 255.247)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3892",
    "data-name": "Trac\\xE9 3892",
    d: "M225.234,109.022h-8.9v12.007h8.9Zm53.644,309.209,1.716-23.247-17.979,1.231.682,23.906Z",
    transform: "translate(705.521 266.356)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3893",
    "data-name": "Trac\\xE9 3893",
    d: "M262.909,243.653l.17,14.621-8.5-1.155-.593-2.244-2.157,2.591-23.188-3.149.627-4.6,13.521-2.669.916-2.758,19.2-.634Z",
    transform: "translate(721.49 440.935)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3894",
    "data-name": "Trac\\xE9 3894",
    d: "M243.588,249.455,241,244.6l-3.482,5.746-3.783-4.033-2.29,4.29-1.711-2.483",
    transform: "translate(722.906 442.158)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3895",
    "data-name": "Trac\\xE9 3895",
    d: "M315.591,249.032l-8.064-21.872-15.854,8.569,10.521,21.479,13.4-8.176Z",
    transform: "translate(803.217 419.548)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3896",
    "data-name": "Trac\\xE9 3896",
    d: "M317.951,236.683l6.217,13.238-8.208,2.464-1.474-1.794-.891,3.25-22.4,6.732-1.337-4.446,11.2-8.029-.308-2.892,17.2-8.523Z",
    transform: "translate(800.856 431.896)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3897",
    "data-name": "Trac\\xE9 3897",
    d: "M303.69,244.591l-4.364-3.355-.792,6.674-5.11-2.1-.312,4.853-2.579-1.55",
    transform: "translate(801.737 437.8)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3898",
    "data-name": "Trac\\xE9 3898",
    d: "M290.618,152.527s8.332,12.581-6.392,24.811l5.572,7.8s21.8-16.715,23.89-22.714l-23.07-9.9Z",
    transform: "translate(793.56 322.77)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3899",
    "data-name": "Trac\\xE9 3899",
    d: "M270.794,230.723c3.909,40.337,54.65,110.77,54.65,110.77l22.211-9.414s-8.415-50.073-20.85-76.639c-10.122-21.578-8.838-57.631-16.3-81.118a65.864,65.864,0,0,0-5.661-13.514l-7.3-1.066-29.671-4.316a672.644,672.644,0,0,0,2.919,75.291",
    transform: "translate(772.227 326.531)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3900",
    "data-name": "Trac\\xE9 3900",
    d: "M339.825,170.317c-1.017,21.536-47.974,66.154-52.347,95.15s-24,85.5-24,85.5l-29.8-3.4s-2.2-83.024,21.309-133.108a233.973,233.973,0,0,1,41.913-61Z",
    transform: "translate(727.945 323.985)",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3901",
    "data-name": "Trac\\xE9 3901",
    d: "M272.613,127.588c-9.55,1.272-14.01-5.328-12.965-13.121.464-3.452,1.279-7.154,3.525-9.892a11.258,11.258,0,0,1,8.114-4.421c6.791-.331,12.6,5.544,12.965,13.119a13.649,13.649,0,0,1-11.64,14.315Z",
    transform: "translate(761.496 254.84)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3902",
    "data-name": "Trac\\xE9 3902",
    d: "M262.638,109.895l-.211,11.134,8.149.156.211-11.137Z",
    transform: "translate(765.293 267.488)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3903",
    "data-name": "Trac\\xE9 3903",
    d: "M264.123,105.831a.868.868,0,1,0,.26-1.16.836.836,0,0,0-.26,1.16Zm-4.047,5.361a19.1,19.1,0,0,1,.609-5.519c.138-.533.974-.42.836.106a18.281,18.281,0,0,0-.59,5.328c0,.533-.838.638-.854.106",
    transform: "translate(762.229 260.528)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3904",
    "data-name": "Trac\\xE9 3904",
    d: "M403.764,217.92c1.886-6.185,2.345-12.928,2.967-19.338,1.72-17.845.1-36.692-8.911-52.608-6.968-12.315-18.257-21.1-31.5-25.868-2.419-1.038-10.014-2.423-12.747-2.774-39.34-6.052-51.442,4.837-67.53,17.611-34.226,27.168-46.536,13.849-50.553-22.439l-21.056.971c-1.392,30.177-.694,88.644,48.842,89.967,8.555.227,13.036-1.332,18.867-3.358,5.531,14.559,4.938,24.014,12.023,35.691,32.537-8.236,54.267-15.246,90.026-13.28a74.528,74.528,0,0,1-3.468-15.932c0,.234.847,11.718,2.258,12.032,5.907,1.268,15.386-1.422,20.776-.687",
    transform: "translate(702.627 270.87)",
    fill: "#a02528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3906",
    "data-name": "Trac\\xE9 3906",
    d: "M214.519,115.487l20.721-.827",
    transform: "translate(703.17 273.667)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3907",
    "data-name": "Trac\\xE9 3907",
    d: "M295.5,172.91s2.483-21.265,1.773-31.727",
    transform: "translate(808.177 308.061)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3908",
    "data-name": "Trac\\xE9 3908",
    d: "M291.28,108.53c11.934,29.389,43.2,10.487,41.7,34.9-2.131,34.843-63.323,21.451-59.342-13.461S291.28,108.53,291.28,108.53Zm-24.641-1.13a19.114,19.114,0,0,1-6.254-.044c3.447-5.737,9.4-9.412,15.983-9.093a16.482,16.482,0,0,1,7.131,2.026c-5.119,3.477-10.707,6.2-16.885,7.111",
    transform: "translate(762.645 252.381)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3909",
    "data-name": "Trac\\xE9 3909",
    d: "M289.073,120.566c-7.873-1.364-15.886-5.71-20.893-11.959a27.855,27.855,0,0,1-4.449-8.521,16.555,16.555,0,0,1,8.321-1.814c10,.487,17.68,9.924,17.138,21.086a12.161,12.161,0,0,1-.117,1.229",
    transform: "translate(766.984 252.395)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3910",
    "data-name": "Trac\\xE9 3910",
    d: "M266.534,115.016c3.824,3.429,7.643,2.749,9.869,0,2.058-2.552,1.732-7.219-2.221-8.167a10.28,10.28,0,0,0-4.878.145,14.4,14.4,0,0,0-2.338,2.131c-1.424,1.64-2.579,3.953-.432,5.884",
    transform: "translate(769.08 263.245)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3911",
    "data-name": "Trac\\xE9 3911",
    d: "M267.1,109.856a4.823,4.823,0,0,1,5.818-1.458c.533.255.239,1.151-.315.893a3.9,3.9,0,0,0-4.72,1.1c-.372.473-1.162-.053-.783-.533Z",
    transform: "translate(771.221 264.989)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3912",
    "data-name": "Trac\\xE9 3912",
    d: "M243.728,162.894s31.04-3.8,38.991-21.711",
    transform: "translate(741.045 308.061)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3913",
    "data-name": "Trac\\xE9 3913",
    d: "M252.254,125.273s11.01-8.47,22.744-8.2",
    transform: "translate(752.102 276.784)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3914",
    "data-name": "Trac\\xE9 3914",
    d: "M358.443,183.616s-7.513-23.753-4.146-41.123M344.183,183.26s.891,9.786-24.136,42.942M292.39,215.567a13.08,13.08,0,0,0,10.873-14.959,13.807,13.807,0,0,0-.6-2.327L277.282,202.3a13.041,13.041,0,0,0,15.108,13.268Zm-58.764,133.7,33.417,5.328m96.462-5.328,26.729-9.674",
    transform: "translate(727.945 309.759)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3915",
    "data-name": "Trac\\xE9 3915",
    d: "M219.926,112.412v-11.1s1.959-2.051,3.532.177v10.919",
    transform: "translate(710.182 255.247)",
    fill: "#efd1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3916",
    "data-name": "Trac\\xE9 3916",
    d: "M376.584,149.21H346.077a4.005,4.005,0,0,1-3.994-3.994V114.709a4,4,0,0,1,3.994-4h30.507a4.012,4.012,0,0,1,4,4v30.507a4.01,4.01,0,0,1-4,3.994Z",
    transform: "translate(868.584 268.549)",
    fill: "#ccddf8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3917",
    "data-name": "Trac\\xE9 3917",
    d: "M374.459,147.229H343.952a4.012,4.012,0,0,1-3.994-4V112.721a4,4,0,0,1,3.994-4h30.507a4.015,4.015,0,0,1,4,4v30.507a4.015,4.015,0,0,1-4,4",
    transform: "translate(865.828 265.972)",
    fill: "#c52b30"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3918",
    "data-name": "Trac\\xE9 3918",
    d: "M344.717,111.994l-1.477,1.474,21.929,21.991,1.477-1.474Z",
    transform: "translate(870.084 270.21)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3919",
    "data-name": "Trac\\xE9 3919",
    d: "M366.03,112.242l-22.99,20.877,1.4,1.548,22.992-20.877-1.406-1.548Z",
    transform: "translate(869.824 270.532)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_21944",
    "data-name": "Groupe 21944",
    transform: "translate(553.775 216.997)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4289",
    "data-name": "Trac\\xE9 4289",
    d: "M581,467.39l2.683,2.683a4.308,4.308,0,0,0,1.644,1.025,5.112,5.112,0,0,0,2.022.257,6.65,6.65,0,0,0,4.205-1.985,6.838,6.838,0,0,0,1.808-3.117,5.4,5.4,0,0,0-.08-3.11,4.3,4.3,0,0,0-1.026-1.643l-10.334-10.335a4.312,4.312,0,0,0-1.643-1.025,5.122,5.122,0,0,0-2.022-.258,5.915,5.915,0,0,0-.818.114l4.244,4.245a8.041,8.041,0,0,1,1.915,3.06,8.87,8.87,0,0,1,.458,3.5A10.384,10.384,0,0,1,581,467.39Z",
    transform: "translate(-271.858 -101.613)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4290",
    "data-name": "Trac\\xE9 4290",
    d: "M508.546,476.438a6.819,6.819,0,0,0-1.79,3.1,5.393,5.393,0,0,0,.081,3.11,4.291,4.291,0,0,0,1.025,1.643l5,5a6.845,6.845,0,0,0,1.79-3.1,5.405,5.405,0,0,0-.081-3.11,4.291,4.291,0,0,0-1.025-1.643Z",
    transform: "translate(-206.371 -126.163)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4291",
    "data-name": "Trac\\xE9 4291",
    d: "M345.093,393.188l-2.682-2.683a4.329,4.329,0,0,0-1.644-1.025,5.111,5.111,0,0,0-2.022-.258,6.643,6.643,0,0,0-4.205,1.986,6.845,6.845,0,0,0-1.811,3.116,5.409,5.409,0,0,0,.081,3.112,4.3,4.3,0,0,0,1.026,1.643l10.336,10.335a4.315,4.315,0,0,0,1.642,1.025,5.116,5.116,0,0,0,2.022.257,5.941,5.941,0,0,0,.818-.112l-4.244-4.244a8.058,8.058,0,0,1-1.914-3.061,8.868,8.868,0,0,1-.458-3.5A10.389,10.389,0,0,1,345.093,393.188Z",
    transform: "translate(-45.569 -45.563)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4292",
    "data-name": "Trac\\xE9 4292",
    d: "M306.492,363.127l2.65,2.65a10.383,10.383,0,0,0,3.056-6.585,8.87,8.87,0,0,0-.458-3.5,8.043,8.043,0,0,0-1.915-3.06l-4.244-4.245-2.942-2.942-3.148-3.148a8.064,8.064,0,0,0-3.061-1.914,9.134,9.134,0,0,0-5.277-.171,10.589,10.589,0,0,0-4.835,2.788,10.385,10.385,0,0,0-3.074,6.607,8.843,8.843,0,0,0,.457,3.5,8.068,8.068,0,0,0,1.916,3.061L295.953,366.5a8.061,8.061,0,0,0,3.061,1.913,9.141,9.141,0,0,0,5.276.172,10.336,10.336,0,0,0,1.737-.624l-2.942-2.942a5.931,5.931,0,0,1-.818.112,5.117,5.117,0,0,1-2.022-.257,4.315,4.315,0,0,1-1.642-1.025l-10.336-10.335a4.3,4.3,0,0,1-1.026-1.643,5.409,5.409,0,0,1-.081-3.111,6.844,6.844,0,0,1,1.811-3.116,6.644,6.644,0,0,1,4.205-1.986,5.111,5.111,0,0,1,2.022.258,4.33,4.33,0,0,1,1.644,1.025l2.682,2.683,2.651,2.65,5,5a4.29,4.29,0,0,1,1.025,1.643,5.405,5.405,0,0,1,.081,3.11A6.846,6.846,0,0,1,306.492,363.127Z",
    fill: "#385b89"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_4293",
    "data-name": "Trac\\xE9 4293",
    d: "M462.974,406.328l-2.651-2.65a10.389,10.389,0,0,0-3.055,6.585,8.867,8.867,0,0,0,.458,3.5,8.058,8.058,0,0,0,1.914,3.061l4.244,4.244,2.942,2.942,3.149,3.148a8.058,8.058,0,0,0,3.061,1.914,9.129,9.129,0,0,0,5.276.171,10.585,10.585,0,0,0,4.835-2.788,10.384,10.384,0,0,0,3.074-6.606,8.876,8.876,0,0,0-.458-3.5,8.058,8.058,0,0,0-1.915-3.06l-10.334-10.334a8.063,8.063,0,0,0-3.061-1.916,9.152,9.152,0,0,0-5.276-.172,10.334,10.334,0,0,0-1.737.625l2.942,2.942a5.911,5.911,0,0,1,.818-.114,5.119,5.119,0,0,1,2.022.258,4.31,4.31,0,0,1,1.643,1.025L481.2,415.94a4.3,4.3,0,0,1,1.026,1.643,5.4,5.4,0,0,1,.08,3.11,6.837,6.837,0,0,1-1.808,3.117,6.65,6.65,0,0,1-4.205,1.985,5.113,5.113,0,0,1-2.022-.257,4.307,4.307,0,0,1-1.644-1.025l-2.683-2.683-2.65-2.65-5-5a4.289,4.289,0,0,1-1.025-1.643,5.394,5.394,0,0,1-.081-3.11A6.819,6.819,0,0,1,462.974,406.328Z",
    transform: "translate(-160.798 -56.054)",
    fill: "#c52b30"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpirationToken);
export default __webpack_public_path__ + "static/media/expirationToken.e908b5dac101f5fa4e1ccffe9ebe2671.svg";
export { ForwardRef as ReactComponent };